export default {"src":"/_next/static/media/icon_info_outline.19c861fe.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};